import type { MarketListing } from '~/api/listings/types'

export const doesMarketHaveTheDeal = (market: MarketListing) => {
  if (!market.pricingStrategyInformation?.dealInformation) return false

  const dealPrice = Number(
    market.pricingStrategyInformation?.dealInformation?.dealPrice?.amount,
  )
  const currentPrice = Number(market.currentBackboxPrice?.amount)

  if (market.hasBackbox) {
    return dealPrice >= currentPrice
  }

  return false
}

export const shouldDisplayUnlockDealButton = (market: MarketListing) => {
  if (!market.pricingStrategyInformation?.dealInformation) return false

  const dealPrice = Number(
    market.pricingStrategyInformation?.dealInformation?.dealPrice?.amount,
  )
  const priceToWinBackbox = Number(market.backboxPrice?.amount)
  const currentPrice = Number(market.currentBackboxPrice?.amount)

  if (!market.hasBackbox) {
    return dealPrice < priceToWinBackbox
  }

  return dealPrice < currentPrice
}

/**
 * This is used to display whether a market listing is using the sales maximizer price
 * Returns true if the minimum price OR target price is below or equal to the sales maximizer price && the market has the backbox
 */
export const isUsingSalesMaximizerPrice = (market: MarketListing) => {
  if (!market.pricingStrategy) return false
  if (market.pricingStrategyInformation?.dealInformation) return false

  const minPrice = Number(market.minimumPrice?.amount)
  const targetPrice = Number(market.price?.amount)

  const priceToCompare = market.minimumPrice?.amount ? minPrice : targetPrice

  const salesMaximizerPrice = Number(
    market.pricingStrategy?.salesMaximizerPrice?.amount,
  )

  if (priceToCompare <= salesMaximizerPrice && market.hasBackbox) {
    return true
  }

  return false
}

/**
 * This is used to display whether a win sales maximizer button should be displayed
 * Returns true if the minimum price OR target price is above the sales maximizer price
 * AND
 * the sales maximizer price is less than the price to win the backbox
 *
 */
export const shouldDisplaySalesMaximizerButton = (market: MarketListing) => {
  if (!market.pricingStrategy) return false
  if (market.pricingStrategyInformation?.dealInformation) return false

  const minPrice = Number(market.minimumPrice?.amount)
  const targetPrice = Number(market.price?.amount)

  const priceToCompare = market.minimumPrice?.amount ? minPrice : targetPrice

  const salesMaximizerPrice = Number(
    market.pricingStrategy?.salesMaximizerPrice?.amount,
  )

  const priceToWinBackbox = Number(market.backboxPrice?.amount)

  const salesMaximizerPriceIsLessThanPriceToWinBackbox =
    salesMaximizerPrice < priceToWinBackbox

  if (
    priceToCompare > salesMaximizerPrice &&
    salesMaximizerPriceIsLessThanPriceToWinBackbox
  ) {
    return true
  }

  return false
}
